// extracted by mini-css-extract-plugin
export default {"ctopImg":"style_ctopImg__vjPZm"};